import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  ...stateAbstract,
  purchasesDetail: {},
  purchasesCount: null,
  purchasesList: [],
  retentionsDetail: {},
  retentionsCount: null,
  retentionsList: []
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
